import React from 'react';
import { Card } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { collectionLogoEndpoint, collectionUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import CollectionTools from '../containers/CollectionTools';
import CollectionLogo from './CollectionLogo';

const CollectionCardItem = ({
  category,
  collection,
  onCheckBoxClick,
  single,
  upward,
}) => {
  const intl = useIntl();
  return (
    <CardItem className="aridhia-collection-list-card">
      <div className="aridhia-card-logo">
        <CollectionLogo
          altText={collection.name}
          src={collectionLogoEndpoint(collection.code)}
          ui={false}
          imageKey={collection.imageKey}
        />
      </div>
      <NameDescriptionCard
        description={collection.description}
        entity="collection"
        link={collectionUrl(collection)}
        markdown
        meta={intl.formatMessage({ id: 'collection.datasets.total.title' }, { count: collection.totalDatasets })}
        name={collection.name}
        onSelect={onCheckBoxClick ? () => onCheckBoxClick(collection.code) : undefined}
        selected={collection.selected}
        single={single}
      >
        <CollectionTools
          iconSize="large"
          url={collectionUrl(collection, '#')}
          upward={upward}
          category={category}
          collection={collection}
          listItem
        />
      </NameDescriptionCard>
      <Card.Content extra content={collection.createdOn} />
    </CardItem>
  );
};

export default CollectionCardItem;
